export default __webpack_public_path__ + "static/media/problema-02.9a851eef.webp";